const BLANK_TEXT = new Set(["", "-", "--", "—", "n/a", "na", "null", "undefined"]);

export const parseNumeric = (value) => {
  if (value === null || value === undefined) {
    return null;
  }
  if (typeof value === "number") {
    return Number.isFinite(value) ? value : null;
  }

  const text = String(value).trim();
  if (!text || BLANK_TEXT.has(text.toLowerCase())) {
    return null;
  }

  const cleaned = text.replace(/[$,]/g, "").replace(/[^\d.-]/g, "");
  if (!cleaned || cleaned === "-" || cleaned === "." || cleaned === "-.") {
    return null;
  }

  const numeric = Number(cleaned);
  return Number.isFinite(numeric) ? numeric : null;
};

export const formatNumber = (value, options = {}) => {
  const { digits, minDigits, fallback = "-" } = options;
  const numeric = parseNumeric(value);
  if (numeric === null) {
    return fallback;
  }

  const maximumFractionDigits =
    digits != null ? digits : Number.isInteger(numeric) ? 0 : 2;
  const minimumFractionDigits = minDigits != null ? minDigits : 0;

  return numeric.toLocaleString("en-US", {
    minimumFractionDigits,
    maximumFractionDigits,
  });
};

export const formatMoney = (value, options = {}) => {
  const { fallback = "-", digits, minDigits } = options;
  const numeric = parseNumeric(value);
  if (numeric === null || numeric === 0) {
    return fallback;
  }

  return `$${formatNumber(numeric, { digits, minDigits, fallback })}`;
};

export const formatMeasure = (value, unit, options = {}) => {
  const { fallback = "-" } = options;
  const formatted = formatNumber(value, { ...options, fallback: null });
  if (formatted == null) {
    return fallback;
  }
  return unit ? `${formatted} ${unit}` : formatted;
};

export const formatPerMile = (value, options = {}) => {
  const { fallback = "-" } = options;
  const numeric = parseNumeric(value);
  if (numeric === null || numeric === 0) {
    return fallback;
  }

  return `$${numeric.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} /mi`;
};
